import "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";

const lazySizesConfig = (window as any).lazySizesConfig || {};
lazySizesConfig.customMedia = {
  "--small": "(max-width: 576px)",
  "--medium": "(max-width: 768px)",
  "--large": "(max-width: 992px)"
};
